var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1749105229063,
    className: "icon",
    viewBox: "0 0 1025 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 19152,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.515 310.067L442.07 505.31c19.456 9.216 44.988 13.79 70.52 13.79 25.532 0 51.063-4.574 70.451-13.79l410.556-195.243c38.775-18.432 38.775-48.537 0-66.97L583.04 47.856c-19.32-9.216-44.92-13.79-70.451-13.79s-51.064 4.574-70.451 13.79L31.446 243.098c-38.707 18.432-38.707 48.605 0.069 66.97z m445.85-195.106c5.802-2.799 18.363-5.94 35.225-5.94s29.423 3.141 35.225 5.94l340.037 161.724-340.037 161.587c-5.734 2.799-18.363 5.94-35.225 5.94s-29.423-3.141-35.158-5.94L137.26 276.617 477.364 114.96zM22.161 548.523l402.296 191.215c25.122 11.946 56.593 17.885 88.064 17.885 30.378 0.41 60.484-5.666 88.064-17.885l402.295-191.215a36.66 36.66 0 0 0 16.862-49.903 40.346 40.346 0 0 0-52.088-17.135L565.496 672.768c-27.716 13.175-78.028 13.175-105.745 0L57.456 481.485A40.414 40.414 0 0 0 4.549 498.21a36.727 36.727 0 0 0 17.613 50.313z m998.468 181.999a40.482 40.482 0 0 0-52.906-16.794L565.496 905.011c-27.716 13.176-78.028 13.176-105.745 0L57.524 713.728a40.414 40.414 0 0 0-52.838 16.794A35.772 35.772 0 0 0 2.5 759.125 37.683 37.683 0 0 0 22.3 780.698L424.526 971.98c25.122 11.878 56.593 17.886 88.064 17.886 31.47 0 62.942-5.94 88.064-17.886l402.295-191.147a36.727 36.727 0 0 0 17.681-50.312z",
    fill: "currentColor",
    "p-id": 19153
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCount);
export default __webpack_public_path__ + "static/media/count.28411522e5fc9ed9de622814db4e7ca0.svg";
export { ForwardRef as ReactComponent };